export const sanitizeRedirectPath = (
  redirectParam: string | null | undefined,
  fallback = "/",
): string => {
  if (!redirectParam) return fallback;

  const trimmed = redirectParam.trim();
  if (!trimmed) return fallback;

  try {
    if (
      trimmed.startsWith("http://") ||
      trimmed.startsWith("https://") ||
      trimmed.startsWith("//") ||
      trimmed.includes("@")
    ) {
      return fallback;
    }

    if (!trimmed.startsWith("/")) {
      return `/${trimmed}`;
    }

    return trimmed;
  } catch {
    return fallback;
  }
};
